module.exports = __webpack_public_path__ + "static/media/belasting-1.f5f6f1c0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/belasting-1.svg
// module id = 116
// module chunks = 0